var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxChecked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-5-5h24v24H-5z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1-1h16v16H-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2276E3",
    d: "M12.808.333H1.192a.86.86 0 00-.859.859v11.616a.86.86 0 00.859.859h11.616a.86.86 0 00.859-.86V1.193a.86.86 0 00-.859-.859zm-2.027 4.358L6.89 9.97a.563.563 0 01-.794.104L3.32 7.85a.556.556 0 11.695-.868L6.34 8.844l3.549-4.813a.556.556 0 11.894.66h-.002z"
  })))));
}
export default SvgCheckboxChecked;